import { Flex } from "@chakra-ui/react";
import About from "../About";
import Contact from "../Contact";
import Home from "../Home";
import Work from "./Work";
import Resume from "../Resume";
import { Parallax } from "react-scroll-parallax";

export default function WorkPage() {
  return (
    <div role="main" style={{ scrollSnapType: "y mandatory" }}>
      <Flex
        scrollSnapType={"y"}
        flexDir={"column"}
        bgAttachment="fixed"
        bgSize="cover"
        backgroundImage={"/images/background1.jpg"}
        backgroundColor={"rgba(252, 250, 246 ,0.4)"}
        backgroundBlendMode={"lighten"}
      >
        <Work />
      </Flex>
    </div>
  );
}
